// The sticky default player (05c) — the last player picked in ANY module's picker is the
// one the next new module opens on, so building a "Sam Kerr dashboard" means picking her
// once. Each module still keeps its own picker; this only seeds brand-new ones.
//
// The store's `selectedPlayer` is the only copy since 05c (main.js kept a local variable
// before, mirrored into the store only when set through the window setter — the gap
// Phase 03 logged). Read it fresh every time: it changes over time. It holds her id
// (ids-1), never her name.
//
// Widgets set it themselves too, right before a row / chip drag, so the module the drop
// creates opens on that exact player.

import { useProtoStore } from "../store/store.js";
import { setStickyTeam } from "./sticky-team.js";
import type { PlayerId } from "../data/players.js";

export function getStickyPlayer(): PlayerId | null {
  return useProtoStore.getState().selectedPlayer;
}

export function setStickyPlayer(id: PlayerId | null): void {
  // A player picked after a team: new modules follow the player again (sticky-team.ts).
  setStickyTeam(null);
  useProtoStore.getState().setSelectedPlayer(id);
}
